import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation, getLanguage } from 'react-multi-lang';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { orderSlice, orderState, tGlassworksValue } from './OrderSlice';

import  { iOrderDetail, Iprintdeliverynote, order_details_extended, storeOrder } from '../../services/api/api';

// Stylesheet
import './Order.css';


import {
  EllipsisLoader,
  ErrorMark,
  MySuccessMark,

} from '../../components/Loader/Loader';
import { Confirm } from '../../components/Alerts/Alerts';
import { havePermission } from '../../services/hoc/permissions';
import { useNavigate, useParams } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import {   checkIfTotallyFilled,
  checkRequestNotRepeated_v2,
    enterButton
  , fetchGlassWorkData, get_index, handleKeyDown, handlePrices, iRow, price_related_keys, setTouchedAll, 
  total_price_calculator} from './common'
import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
 
} from '@mui/material';
import EditbleTable from '../../components/editble-table/Editable_table_v1';
import {  useFormik } from 'formik';
import GreenButton from '../../components/buttons/green-button';
import WhiteButton from '../../components/buttons/white-button';
import {
  Cancel,
  Save,
  Print,
  Delete,
  Launch,
  CarCrash,
  BuildCircle,
  MonetizationOn
} from '@mui/icons-material';

import { useGetGlasses } from '../../services/query/useGetGlasses';
import { useGetPrices } from '../../services/query/useGetPrices';

import { PrintOrder } from '../../components/print/print_order';
import { Wait } from '../../components/wait';
import { PrintDeliveryOrder } from '../../components/print/print_delivery_order';
import { IconButton } from '../../components/icon-button';
import { useNotification } from '../../services/usenotification';
import { ordersSlice, } from '../Orders/OrdersSlice';
import { AxiosError } from 'axios';
import Backbutton from '../../components/buttons/backbutton/backbutton';

import OrderStatusMenu from '../../components/OrderStatusMenue/OrderStatusMenu';
import OperationStatus from '../../components/OrderStatus/orderStatus';
import InputTable from '../../components/editble-table/input_table';
import { PrintPrices } from '../../components/print/print_prices';
import Title from '../../components/Title/Title';
import SettingContext from '../../services/context/setting-contentxt/setting-context';
import { EditOrderValidation } from './validation';
import { convertDate } from '../../services/convertDate';
import store from '../../services/store/store';
import { useAPI } from '../../services/hoc/useAPI';
import { useCookies } from 'react-cookie';
import { SmartInput } from '../../components/FormElements/FormElements';
import { useDebounce } from '../../services/hoc/useDebounce';


interface isummaries {
  summary: string,
  glass_summary: string,
  glass_work_summary: string,
  glass_ids: number[],
  glass_work_ids: number[]
}

interface formikInitials extends storeOrder {


}

const  EditOrder=(props: any) => {
  // Translation
  const t = useTranslation();
  const selection_depend_on = useRef<null | string>('glasses')
  const {debounce,handlDebounce} = useDebounce(500)


  const { alert, alertError500 } = useNotification();
  const { orderid } = useParams();
  const [isSucceed, setIsSucceed] = useState(false);
  const [cookie] =useCookies()
  const [isFailed, setIsFailed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [printOrder, setPrintOrder] = useState({ open: false, data: {} });
  const [printPricse, setPrintPrices] = useState <{open:boolean,data?:storeOrder}>({ open: false })
  const [summaries, setSummaries] = useState<isummaries>({
    summary: '',
    glass_summary: '',
    glass_work_summary: '',
    glass_ids: [],
    glass_work_ids: []
  });
 
 
  const ref1 = useRef<any>(null);
  const ref2 = useRef<any>(null);
  const ref3 = useRef<any>(null);
  const ref4 = useRef<any>(null);
  const ref5 = useRef<any>(null);
  const ref6 = useRef<any>(null);
  const ref7 = useRef<any>(null);
  const ref8 = useRef<any>(null);
  const [row, setRow] = useState<iRow>({});
  const formik = useFormik<formikInitials>({
    initialValues: {
      glass_summary: '',
      glass_work_summary: '',
      client_id: -1,
      order_no: '',
      date: '',
      delivery_date: '',
      summary: '',

    },
    onSubmit: () => { },
    validationSchema: EditOrderValidation

  });

  // Redux
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isFetchingGlassWork, setIsFetchingGlassWork] = useState(false);
 
  const { isPc , isMobile} = useContext(SettingContext)

  const state = useSelector((state: { order: orderState }) => state.order);
  const { getGlasses, glassesData, glassesDataLoading, glassesError } =
    useGetGlasses();

  const { getPrices, pricesData, pricesDataLoading, pricesError
    , pricesByGlassData, pricesByGlassError
    , pricesByGlassworkData, pricesByGlassworkError } =
    useGetPrices()
  // Hooks

  const [deliveryOrderPrint, setDeliveryOrderPrint] = useState<{open?:boolean,data?:Iprintdeliverynote}>();
  const [wait, setWait] = useState(false);
  const ENDPOINTS = useAPI()

  const handleStaticFunction = (orderStatus: string, order_id = 0, bill_id = 0, orderStatus_code: number) => {

    return (
      <>
        {orderStatus_code >= 2 &&
          (
            <div>
            <IconButton
              DoIcon={<MonetizationOn sx={{ color: 'var(--primary-color)' }} />}
              cancelTitle=''
              doTitle={t("order_review")}
              value={false}
              disabled={!havePermission("Print Job Order")}
              style={{ margin: '0 5px' }}
              doFunction={async () => {
                 
                setPrintPrices(pre=>({open:true,data:{...formik.values}}))
             
                return true
              }}
            />
            </div>
            )}
        {orderStatus_code >= 4 && (
          <div>
          <IconButton
            DoIcon={<BuildCircle sx={{ color: 'var(--primary-color)' }} />}
            cancelTitle=''
            doTitle={t("print_job_order")}
            value={false}
            disabled={!havePermission("Print Job Order")}
            style={{ margin: '0 5px' }}
            doFunction={() => {
              {
                let res = ENDPOINTS.orders().printOrder({ id: order_id ? order_id : 0 })

                  .then((res: any) => {
                    if (res.data.data) {
                      if (res.data.data){

                        setPrintOrder(pre => ({ ...pre, data: res.data.data, open: true }))
                      }
                      else {
                        alert({en:"Job order can't be printed than once",ar:'لا يمكن طباعة أمر الشغل أكثر من مرة'},'warning')
                      }
                    }
                    return true
                  })
                  .catch((err: any) => {
                    alertError500(err)
                    return true
                  }
                  )
                return res
              }
            }}
          />
          </div>
          )}
        {orderStatus_code >= 6 && (<>
        <div>
          <IconButton
            DoIcon={<CarCrash sx={{ color: 'var(--primary-color)' }} />}
            cancelTitle=''
            doTitle={t("print_delivery_order")}
            value={false}
            disabled={!havePermission("Print Delivery Order")}

            style={{ margin: '0 5px' }}
            doFunction={() => {
              {
                let res = ENDPOINTS.bills().printDeliveryOrder({ id: bill_id ?? 0 })

                  .then((res) => {

                    if (res.data.data) {

                      setDeliveryOrderPrint(pre => ({ ...pre, data: res.data.data, open: true }))
                    }
                    return true
                  })
                  .catch((err: any) => {

                    alertError500(err)
                    return true
                  }
                  )
                return res
              }
            }}
          />
</div>

        </>)}
        {
          orderStatus_code >= 3 && (
            <div>
            <IconButton
              DoIcon={<Launch sx={{ color: 'var(--primary-color)' }} />}
              cancelTitle=''
              doTitle={t("show_invoice")}
              value={false}


              style={{ margin: '0 5px' }}
              doFunction={() => {
                {
                  navigate(`/bills/${bill_id}`)
                  return true
                }
              }}
            />
            </div>
            )
        }
   </>
    )

  }
  const dispatch_glasswork = (index: number, data: tGlassworksValue[]) => {
   
    dispatch(
      orderSlice.actions.setGlassWords({
        data,
        index: index,
      }))


  }


  const handleFetchingGlassWorkData = async (list_glass: number[]) => {

    for (let i = 0; i < list_glass.length; i++) {

      initGlasswork(i, list_glass[i])
    }
  }

  const fetchData = (id: number) => {
    dispatch(orderSlice.actions.setIsFetching(true));

    ENDPOINTS.orders()
      .show({ id: id })
      .then((response) => {
        let { glass_summary, glass_work_summary, summary } = response.data
          .data ?? { glass_summary: '', glass_work_summary: '', summary: '' };
        let list_glass = response.data.data.orderdetail?.map((ele) => ele.glass_id ?? -1)
        if (list_glass && list_glass.length > 0) {
          handleFetchingGlassWorkData(list_glass)
        }

        dispatch(orderSlice.actions.setIsLoaded(true));
        dispatch(orderSlice.actions.setIsFetching(false));
        dispatch(orderSlice.actions.setOrder(response.data.data));
        setSummaries((pre) => ({
          ...pre,
          summary: summary ?? '',
          glass_summary: glass_summary ?? '',
          glass_work_summary: glass_work_summary ?? '',
        }));
        dispatch(
          orderSlice.actions.setClient({
            client: {
              type: 'client',
              data: {
                id: response.data.data.client_id ?? -1,
                name: response.data.data.client_name ?? '',
              },
            },
            phone: response.data.data.client?.phone,
            address: response.data.data.client?.address_1,
          }),
        );

        let order_details = response.data.data.orderdetail?.map((ele, i) => {
          let unit=ele.glass_work?.unit ??'Area'
          let min_area= ele.glass_work?.min_area??0
          let width = ele.width??0
          let length = ele.length ??0
          let price = ele.price??0
         
          let total_price = total_price_calculator(width,length,ele.piece_count??0,price,min_area,unit)
          
          return ({
            glass_code: ele.glass?.code ?? '',
            glass_id: ele.glass_id ?? -1,
            glass_work_id: ele.glass_work_id ?? -1,
            glasswork_code: ele.glass_work?.code ?? '',
            length: ele.length ?? 0,
            piece_code: ele.piece_code ?? '',
            piece_count: ele.piece_count?? 0,
            total_price,
            price:price,
            width: ele.width ?? 0,
            serial_number: i,
            area:ele.area,
            glass:ele.glass,
            glass_work:ele.glass_work
          

          })
        }
        )
        formik.resetForm({
          values: {
            client_id: response.data.data.client_id ?? -1,
            date: response.data.data.date ?? '',
            order_no: response.data.data.order_no ?? '',
            summary: response.data.data.summary ?? '',
            delivery_date: response.data.data.delivery_date ?? '',
            order_details: order_details,
            glass_summary: response.data.data.glass_summary ?? '',
            glass_work_summary: response.data.data.glass_work_summary ?? "",
            client:response.data.data.client
          }
        })
      });
  };




  // First fetch
  useEffect(() => {
    if (!state.isFetching) {
      if (orderid) {
        fetchData(parseInt(orderid));
        //fetchGlasses()
        //fetchPricing()
      if (glassesData && glassesData.length==0)  getGlasses(1);
        //getGlassesWorks(1);
      if ( pricesData && pricesData.length == 0)  getPrices(1);
      }
    }
  }, [orderid]);

  useEffect(() => {
    if (!glassesError) {
      if (glassesData && glassesData.length > 0) {
        let data = glassesData.map((ele) => ({ ...ele, value: ele.id }));
        dispatch(orderSlice.actions.setGlasses({ data, index: 'general' }));
      }
    }
  }, [glassesDataLoading]);

 
  useEffect(() => {
    if (!pricesError) {
      if (pricesData && pricesData.length > 0) {
        dispatch(orderSlice.actions.setPricing(pricesData));
      }
    }
  }, [pricesDataLoading]);


  

  useEffect(() => {
    if (!pricesByGlassError) {
      let selected_glassworks = pricesByGlassData.length > 0 ? pricesByGlassData : null
      if (
        selected_glassworks &&
        selected_glassworks.length > 0 &&
        selection_depend_on.current === "glasses"
      ) {
        let data = selected_glassworks
          .map((ele: any) => ({
            ...ele,
            value: ele.gwid,
            name: ele.gwname
          })).filter(ele => ele.is_priced === 1);
        let selectedGlassWorks = data
          ? data.filter(
            (ele) =>
              ele.gwid ===

              row?.glass_work_id,

          )
          : null

        if (selectedGlassWorks && selectedGlassWorks.length === 0) {
          let new_values = { ...row }

          new_values.glasswork_code = ''
          new_values.glass_work_id = -1

          handleSummaries()
          setRow(pre => ({ ...pre, ...new_values }))



        }
        // dispatch(
        //   orderSlice.actions.setGlassWords({
        //     data,
        //     index: 0,
        //   }),
        // );
      } else {
       
        let new_values = { ...row }
        if (new_values) {
          new_values['glasswork_code'] = ''
          new_values['glass_work_id'] = -1

          handleSummaries()
          setRow((pre: any) => ({ ...pre, ...new_values }))
         
        }
      }
    }
  }, [pricesByGlassData])

  useEffect(() => {
    if (!pricesByGlassworkError) {
      let selected_glasses = pricesByGlassworkData.length > 0 ? pricesByGlassworkData : null

      if (

        selected_glasses &&

        selected_glasses.length > 0 &&
        selection_depend_on.current === "glassworks"

      ) {

        let data = selected_glasses.map((ele: any) => ({
          ...ele,
          value: ele.gid,
          name: ele.gname
        }));

        dispatch(
          orderSlice.actions.setGlasses({ data, index: 0 }),
        );
      } else {
        let data: any[] | null = Boolean(selection_depend_on.current) &&
          selection_depend_on.current === "glassworks"
          ? [] : null;;

        dispatch(
          orderSlice.actions.setGlasses({ data, index: 0 }),
        );
      }
    }
  }, [pricesByGlassworkData])

 


  const generateTableBody = () => (
    <TableRow
      style={{
        width: '100%',
      }}
      sx={{
        '.MuiTableCell-root': {
          borderColor: 'lightgray',
          borderLeft: '1px solid lightgray',
          borderLeftStyle: 'groove',
          padding:'1px'
        },
      }}>
      {isPc &&
        <TableCell>
          {enterButton(enterClicked)}
        </TableCell>}
      <TableCell
        
        align="right"
      >
        <select
          style={{  width: '190px' }}
          ref={ref1}
          className="select tab_element_inputTable"
          name="glass_work_id"
          onKeyDown={handleKeyDown}
          value={row?.glass_work_id}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            handleRow(e)
          }>
          <option value={''}></option>
          {state.glassWorks[-999]
            ? state.glassWorks[-999].map((ele, index) => (
              <option value={ele.value ?? ''} key={`${index}-${ele}`}>
                {ele.name ?? ''}
              </option>
            ))
            : null}
        </select>
      </TableCell>
      <TableCell align="right" >
        <SmartInput
          ref={ref2}
          className="input  table_input tab_element_inputTable"
          value={row?.glasswork_code??''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleRow(e)
          }
          name="glasswork_code"
          onKeyDown={handleKeyDown}
        />
      </TableCell>
      <TableCell align="right" >
        <SmartInput
          ref={ref3}
          className="input  table_input tab_element_inputTable"
          value={row?.piece_code??''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleRow(e)
          }
          name="piece_code"
          onKeyDown={handleKeyDown}
        />
      </TableCell>
      <TableCell  align="right">
        <SmartInput
          ref={ref4}
          className="input  table_input tab_element_inputTable"
          value={row?.length??''}
          onKeyDown={handleKeyDown}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleRow(e)
          }
          name="length"
          type="number"
        />
      </TableCell>
      <TableCell >
        <SmartInput
          ref={ref5}
          className="input  table_input tab_element_inputTable"
          value={row?.width??''}
          onKeyDown={handleKeyDown}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleRow(e)
          }
          name="width"
          type="number"
        />
      </TableCell>
      <TableCell >
        <SmartInput
          ref={ref6}
          className="input  table_input tab_element_inputTable"
          value={row?.piece_count??''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleRow(e)
          }
          name="piece_count"
          type="number"
          onKeyDown={handleKeyDown}
        />
      </TableCell>

      <TableCell >
        <select
          style={{  width: '190px'}}
          ref={ref7}
          className="select tab_element_inputTable"
          onKeyDown={handleKeyDown}
          name="glass_id"
          value={row?.glass_id??''}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            handleRow(e)
          }
        >
          <option value={''}></option>
          {state.glasses['general']
            ? state.glasses['general'].map((ele, index) => (
              <option value={ele.value ?? ''} key={`${index}-${ele}`}>
                {ele.name ?? ''}
              </option>
            ))
            : null}
        </select>
      </TableCell>
      <TableCell >
        <SmartInput
          ref={ref8}
          onKeyDown={handleKeyDown}
          className="input  table_input tab_element_inputTable "
          value={row?.glass_code}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleRow(e)
          }
          name="glass_code"
        />
      </TableCell>

    </TableRow>
  );

  const enterClicked = () => {
    let totally_filled =false
   if (row) totally_filled = checkIfTotallyFilled(row);

    if (totally_filled) {
      if (havePermission('Edit Order')) {
        if (state.operationsStatus[0].status === "Open") {
          addValuesTable();
        }
        else {
          let message = getLanguage() === "en" ? "you can't edit order its status is not Open" :
            "لا يمكنك تعديل طلبية حالتها ليست مفتوحة"
          alert({ en: message, ar: message }, 'info')
        }
      }
      else {
        let message = t('no_edit_permission')
        alert({ en: message, ar: message }, 'info')

      }
    } else {
      alert(
        {
          en: 'Please you have to fill all the fileds',
          ar: 'رجاءا أدخل كل القيم أولا',
        },
        'info',
      );
    }
  };

  const setRowValue = (empty_row: iRow, index?: number) => {
    if (index && index === 0) {
      let [single_price,total_price,price , raw_price,min_area] = handlePrices(row,state)
      formik.setFieldValue('order_details', [{
        ...row,
        glass_id: row?.glass_id
        , glass_work_id: row?.glass_work_id
        ,single_price:single_price,
        price:price,
        total_price ,
        area:min_area
        , serial_number: 1
      }]);
      setRow((pre: iRow) => empty_row);
    } else {
      if (row){
      let [single_price, total_price,price , raw_price,min_arae] = handlePrices(row,state)
      
      let new_array = formik.values.order_details ? [...formik.values.order_details] : [];
      let new_row = {
        ...row
        , serial_number: index
        , glass_id: row.glass_id
        , glass_work_id: row.glass_work_id,
        single_price,
        total_price,
        price:price,
        area:min_arae
      };
      new_array.push(new_row);
      formik.setFieldValue('order_details', new_array);
      setRow((pre) => empty_row);
    }
    }
  }


  
  

const initGlasswork = async (index: number, glass_id: number) => {
      let fetched_ids = store.getState().order.fetched_ids
      let glassworks = store.getState().order.fetched_glassworks
      let request_is_made = checkRequestNotRepeated_v2(fetched_ids, glass_id)
      let is_existed: tGlassworksValue[] | null = null
      if (request_is_made) {
        let found_index = get_index(fetched_ids, glass_id)
        if (found_index > -1 ) is_existed = glassworks [found_index]
        if (is_existed) {
        dispatch_glasswork(index, is_existed)
        }
        else {
          
          dispatch(orderSlice.actions.setIdsPendingFetch({index,glass_id}))
         
        }
      }
    

      else if ( !request_is_made) {
        
          let new_index = null
      
 
          let keys_fetched_ids =Object.keys(fetched_ids)
          new_index= keys_fetched_ids.length>0 ?  Math.max(...keys_fetched_ids.map(ele=>parseInt(ele))) + 1 :0
            
           
          dispatch(orderSlice.actions.setFetchedIds({index:new_index,glass_id}))
          let response = await fetchGlassWorkData(glass_id
            , index
            , ENDPOINTS
            , setIsFetchingGlassWork
          )
          if (response.data) {
          
            dispatch_glasswork(response.index, response.data)

          }
        }
  }
  


 

   const handleFetchingGlasswork_v2 = async (index: number, glass_id: number) => {
      
      let request_is_made = checkRequestNotRepeated_v2(state.fetched_ids, glass_id)
      let is_existed: tGlassworksValue[] | null = null
      //is_existed = checke_GlassWork_existing(glass_id, state.glassWorks)

      if (request_is_made) {
              let found_index = get_index(state.fetched_ids, glass_id)
              if (found_index > -1 ) is_existed = state.fetched_glassworks [found_index]
            
              if (is_existed) {
              dispatch_glasswork(index, is_existed)
              }
              else {
                 
                dispatch(orderSlice.actions.setIdsPendingFetch({index,glass_id}))
               
              }
            }
      else {
          if (!isFetchingGlassWork ) {
             let new_index = null
      
  
            let keys_fetched_ids =Object.keys(state.fetched_ids)
            new_index= keys_fetched_ids.length>0 ?  Math.max(...keys_fetched_ids.map(ele=>parseInt(ele))) + 1 :0
            
           
             dispatch(orderSlice.actions.setFetchedIds({index:new_index,glass_id}))

                      
          let response = await fetchGlassWorkData(glass_id
            , index
            , ENDPOINTS
            , setIsFetchingGlassWork
          )
          if (response.data) {
  
            dispatch_glasswork(response.index, response.data)
  
          }
        }
      }
    }

  const addValuesTable = async () => {


    let empty_row:iRow = {
      glass_id:undefined,
      glass_code:'',
    
      glass_work_id:undefined,
      glasswork_code:'',
      length:undefined,
      width:undefined,
      piece_code:'',
      piece_count:undefined,


    };
    let index = formik.values.order_details?.length;
    if (index !== undefined) {
      handleFetchingGlasswork_v2(index, row?.glass_id??-1)
      dispatch(orderSlice.actions.deleteGlassWorks({arr_index:['-999']}))
      setRowValue(empty_row, index)
    }




  };


  const handleRow = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    if (state.order.orderstatus && state.order.orderstatus[0].code >= 3) return

    if (e.target.name.includes("glass_id")) {
 
      let { glass_code } = handleCode({ index: -999, glass_id: parseInt(e.target.value) })
      
      handleFetchingGlasswork_v2(-999, parseInt(e.target.value))


      setRow(pre =>({ ...pre, glass_code: glass_code, glass_id: parseInt(e.target.value )}))
    }

    else if (e.target.name.includes("glass_work_id")) {
      let { glass_work_code } = handleCode({ index: -999, glass_work_id: parseInt(e.target.value) })
      setRow(pre => ({
        ...pre, glasswork_code: glass_work_code
        , glass_work_id: parseInt(e.target.value)
      }))
    }

    else if (e.target.name.includes("glass_code")){
      let {glass_id} = handleGlass_Glasswork({index:-999,glass_code:e.target.value})
       if (glass_id) handleFetchingGlasswork_v2(-999,glass_id)
      setRow(pre=>({...pre,
                    glass_id:glass_id??-1
                    ,glass_code:e.target.value
                    ,glass_work_id:-1
                    ,glasswork_code:''
  }))
    }
    else if (e.target.name.includes("glasswork_code")) {
     let {glass_work_id} = handleGlass_Glasswork({index:-999,glass_work_code:e.target.value})
     setRow(pre=>({...pre,glass_work_id:glass_work_id??-1,glasswork_code:e.target.value}))
    }
   
    else {

      setRow((pre: iRow) =>({ ...pre, [e.target.name]: e.target.value }))
    }
  }



  const handleCode =
    ({ index, glass_id, glass_work_id }: { index: number, glass_id?: number, glass_work_id?: number })
      : { glass_code: string, glass_work_code: string , price ? : number } => {

      let glass_code = ''
      let glass_work_code = ""
      let price=0
      if (glass_id) {
        let selectedGlass = state.glasses['general']
          ? state.glasses['general'].filter(
            (ele) =>
              ele.id === glass_id,
          )
          : null;
        if (selectedGlass && selectedGlass[0]) {
          glass_code = selectedGlass[0].code ?? ''
        }
      }
      if (glass_work_id) {
        let selectedGlassWorks = state.glassWorks[index]
          ? state.glassWorks[index].filter(
            (ele) =>
              ele.gwid === glass_work_id,
          )
          : null;
       
        if (selectedGlassWorks && selectedGlassWorks[0]) {
          
          glass_work_code = selectedGlassWorks[0].gwcode ?? ''
          
          price = selectedGlassWorks[0].price ?? 0
        }
      }
      
      return { glass_code, glass_work_code , price }
    }

    const handleGlass_Glasswork=
    ({index,glass_code,glass_work_code}:{index:number,glass_code?:string,glass_work_code?:string})
    :{glass_id?:number,glass_work_id?:number,price?:number}=>{
     
      let glass_id=undefined
      let glass_work_id=-1
      let price = undefined
      if (glass_code){
      let selectedGlass = state.glasses['general']
        ? state.glasses['general'].filter(
          (ele) =>
            ele.code === glass_code,
        )
        : null;
        if (selectedGlass && selectedGlass[0]) {
          glass_id=selectedGlass[0].id
        }
       }
        if (glass_work_code){
          let selectedGlassWorks = state.glassWorks[index]
          ? state.glassWorks[index].filter(
            (ele) =>
              ele.gwcode === glass_work_code,
          )
          : null;
        
          if (selectedGlassWorks && selectedGlassWorks[0]){
          
              glass_work_id=selectedGlassWorks[0].gwid??-1
              price=selectedGlassWorks[0].price
          }
        }
        return {glass_id,glass_work_id,price}
    }

  const setGlassId = (index: number, glass_id: number) => {
    if (formik.values.order_details && formik.values.order_details.length > 0) {
      let { glass_code ,price } = handleCode({ index, glass_id })

      let new_orderdetails = [...formik.values.order_details]
      new_orderdetails[index].glass_id = glass_id
      new_orderdetails[index].glass_work_id = -1
      new_orderdetails[index].glass_code = glass_code
      new_orderdetails[index].glasswork_code = ''
      new_orderdetails[index].price=0
      new_orderdetails[index].total_price=0
      new_orderdetails[index].raw_price=0

      formik.setFieldValue("order_details", [...new_orderdetails])

    }
  }

  const setGlassWorkId = (index: number, glass_work_id: number) => {
    if (formik.values.order_details && formik.values.order_details.length > 0) {
      let { glass_work_code  } = handleCode({ index, glass_work_id })

      let new_orderdetails = [...formik.values.order_details]
      new_orderdetails[index].glass_work_id = glass_work_id
      new_orderdetails[index].glasswork_code = glass_work_code
      //new_orderdetails[index].price=price
      new_orderdetails[index]['total_price']=0
      new_orderdetails[index]['price']=0
      let [single_price,total_price,price,raw_price,min_arae] = handlePrices(new_orderdetails[index],state)
        new_orderdetails[index]['total_price']=total_price
        new_orderdetails[index]['price']=price
        new_orderdetails[index]['single_price']=single_price
        new_orderdetails[index]['raw_price']=raw_price
        new_orderdetails[index]['area']=min_arae
        
         

    
      formik.setValues(pre => ({ ...pre, order_details: new_orderdetails }))
    }
  }

  //  const fetchRawPrice = (glass_id:number,glass_work_id:number):[number,number]=>{
  //       let list_glasses = Object.values(state.fetched_glassworks)
  //       if (list_glasses.length === 0){ 
    
  //         return [-1,-1]}
  //       let selected_glasswork : undefined|tGlassworksValue =undefined 
  //       list_glasses.filter(ele=>
  //       {
  //          if (ele[0].gid?.toPrecision() === glass_id.toString() ){
  //             selected_glasswork= ele.filter(elem=>elem.gwid?.toString()===glass_work_id.toString())[0]
  //          }
  //       }
  //         )
         
  //         if (selected_glasswork === undefined){ 
           
  //           return [-1,-1]}
         
  //       return [selected_glasswork['price']??0, selected_glasswork['min_area']]
       
        
  //      }

  
  
    const setPrices=(index:number,input_name:price_related_keys,input_value:string)=>{
      if (formik.values.order_details && formik.values.order_details.length > 0) {
        let new_orderdetails = [...formik.values.order_details]
         let target_line = new_orderdetails[index]
         target_line[input_name]= parseFloat(input_value)
          let [single_price ,total_price,price,raw_price,minarea] =handlePrices( target_line,state)
          target_line.single_price=single_price
          target_line.total_price = total_price
          target_line.price=price
          target_line.raw_price=raw_price
          target_line.area=minarea
          formik.setValues(pre => ({ ...pre, order_details: new_orderdetails }))
        }
       }

   
     
    //  const handlePrices = (values:iOrderDetail,index?:number)=>{

    //   let glass_id =undefined
    //   let glass_work_id=undefined
    //   let width= undefined
    //   let length=undefined
    //   let price=values['price'] ? values['price'] : undefined
    //   let single_price=undefined
    //   let total_price =0
    //   let min_area = -1
    //   let piece_count = undefined
    //   let raw_price = -1
  
    //   if ('glass_id' in values) glass_id=values['glass_id']
    //   if ('glass_work_id' in  values) glass_work_id = values['glass_work_id']
    //   if ('width' in values) width = values['width']
    //   if ('length' in values) length=values['length']
    //   if ('piece_count' in values) piece_count = values['piece_count']
    //   if (glass_id && glass_work_id) [raw_price,min_area]=fetchRawPrice(glass_id,glass_work_id)
    //   if (width && length) single_price=calculate_single_price(price && price > 0 ? price : raw_price,width,length,min_area)
    //   if (single_price &&piece_count ) total_price = calculate_total_price(single_price,piece_count) 
    //   let area = ((width??0) * (length??0) )/10000
    //   return [single_price,total_price,price && price > 0 ? price : raw_price,raw_price,min_area >area? min_area:area]  
      
    //  }


  const setGlassWorkCode=(index:number,glasswork_code:string)=>{
    if (formik.values.order_details && formik.values.order_details.length > 0) {
      let {glass_work_id}=handleGlass_Glasswork({index,glass_work_code:glasswork_code})
      
      let new_orderdetails = [...formik.values.order_details]
      new_orderdetails[index].glass_work_id = glass_work_id
      new_orderdetails[index].glasswork_code=glasswork_code
      new_orderdetails[index]['price']=0
  
      // let [single_price,total_price,price,raw_price] = handlePrices(new_orderdetails[index])
      //   new_orderdetails[index]['total_price']=total_price
      //   new_orderdetails[index]['price']=price
      //   new_orderdetails[index]['single_price']=single_price
      //   new_orderdetails[index]['raw_price']=raw_price
      handlDebounce({key_trigger:'glasswork_code'
                    ,values:new_orderdetails
                    ,helper:{index}})

      
      formik.setValues(pre => ({ ...pre, order_details: new_orderdetails }))
    }
  }
  
  const setGlassCode=(index:number,glass_code:string):number|undefined=>{
    let glass_id=undefined
    if (formik.values.order_details && formik.values.order_details.length > 0) {
       let resu=handleGlass_Glasswork({index,glass_code})
       glass_id=resu.glass_id
      let new_orderdetails = [...formik.values.order_details]
      new_orderdetails[index].glass_id = glass_id
      new_orderdetails[index].glass_code=glass_code
      new_orderdetails[index].glass_work_id=-1
      new_orderdetails[index].glasswork_code=""
      new_orderdetails[index].price=0
      new_orderdetails[index].total_price=0
      new_orderdetails[index].raw_price=0
      // let [single_price,total_price,price,raw_price] = handlePrices(new_orderdetails[index])
      //   new_orderdetails[index]['total_price']=total_price
      //   new_orderdetails[index]['price']=price
      //   new_orderdetails[index]['single_price']=single_price
      //   new_orderdetails[index]['raw_price']=raw_price
      // handlDebounce({key_trigger:'glass_code'
      //               ,values:new_orderdetails
      //               ,helper:{index}
      // })

      
      formik.setValues(pre => ({ ...pre, order_details: new_orderdetails }))
    }
    return glass_id
  }

  const customHandleChange = (e: React.ChangeEvent, index: number) => {
    if (havePermission('Edit Order')) {

      let target = e.target as HTMLInputElement
      let relate_prices_keys = ['width','length','piece_count']
      let prices_keys = ['price']
      let match = target.name.match(/\[(\w+)\]$/)
      let _input_name = match ? match[1] : ''
  
      if (target.name.includes("glass_id")) {
        handleFetchingGlasswork_v2(index, parseInt(target.value))

        setGlassId(index, parseInt(target.value))
      }
      else if (target.name.includes("glass_work_id")) {
        setGlassWorkId(index, parseInt(target.value))
      }
        
      else if (target.name.includes("glasswork_code")){
        setGlassWorkCode(index,target.value)
      }
      else if (target.name.includes("glass_code")){
      let glass_id=  setGlassCode(index,target.value)
       if (glass_id) handleFetchingGlasswork_v2(index,glass_id)
      }
       else if (relate_prices_keys.includes(_input_name)){
           setPrices(index,_input_name as price_related_keys,target.value)
   
         }
         else if (prices_keys.includes(_input_name)) {
          if (state.order&& state.order.orderstatus && state.order.orderstatus[0].code > 1)return 
          let values = formik.values.order_details?[...formik.values.order_details]:[]
          values[index]['price']=parseInt(target.value)
          let [single_price ,total_price,price,raw_price] =handlePrices( values[index],state)
          values[index]['total_price']=total_price
          values[index]['raw_price']=raw_price
          
          //formik.setFieldValue(`order_details[${index}][price]`,target.value,false)
          formik.setValues(pre=>({...pre ,order_details:values}))
         }
      
      else {

        formik.handleChange(e);
      }
    } else {
      let message = t('no_add_permission');
      alert({ en: message, ar: message }, 'info');
    }
  };

  const submit = () => {
    if (formik.isValid) {

      let glass_summary = ''
      let glass_work_summary = ''
      let summary_results = handleSummaries()
      if (summary_results) {
        glass_summary = summary_results.glass_summary
        glass_work_summary = summary_results.glass_work_summary
      }
      setIsLoading(true);
      ENDPOINTS.orders()
        .update(
          {
            id: state.order.id ?? -1,
            client_id: formik.values.client_id ?? -1,
            date: formik.values.date ? convertDate(formik.values.date) : '',
            order_no: formik.values.order_no ?? '',
            summary: formik.values.summary ?? '',
            delivery_date: formik.values.delivery_date ? convertDate(formik.values.delivery_date) : '',
            status: state.operationsStatus[0].status,
            glass_summary: glass_summary,
            glass_work_summary: glass_work_summary,
            order_details: formik.values.order_details?.map(ele =>
            ({
            
               piece_code:ele.piece_code,
               piece_count:ele.piece_count,
               length:ele.length,
               width :ele.width
              , glass_id: ele.glass_id
              , glass_work_id: ele.glass_work_id
              , area: ele.area
              , total: ele.total_price
              , price: ele.price
            }))
          })
        .then((res: any) => {
          setIsLoading(false);
          setIsSucceed(true);
        })
        .catch((err: any) => {
          setIsLoading(false);
          setIsFailed(true);
          alertError500(err)
        });
    }
    else {
      setTouchedAll(formik.setTouched, formik.errors)
    }
  };

  const handleCopyLine = (arr_index: string[]) => {

    if (formik.values.order_details 
      && formik.values.order_details?.length >= arr_index.length) {
      let new_rows = arr_index.map(ele =>
      ({...formik.values.order_details?.[parseInt(ele)]})
      )
      let new_details = [
        ...formik.values.order_details,
        ...new_rows
      ];
      dispatch(orderSlice.actions.copyGlassWorks({ arr_index }))
      formik.setFieldValue('order_details', new_details);

    }
  };


  const handleRemoveLine = (arr_index: string[]) => {
    
    if (havePermission('Edit Order')) {


      let new_order_details = formik.values.order_details ?
        [...formik.values.order_details].filter((ele, i) => !arr_index.includes(i.toString())) : []
      dispatch(orderSlice.actions.deleteGlassWorks({ arr_index }))
  

        //remove_id_glass_id_fetched(arr_index.map(ele=>parseInt(ele)))
      
      formik.resetForm({ values: { ...formik.values, order_details: new_order_details } });
    }
    else {
      let message = t('no_edit_permission')
      alert({ en: message, ar: message }, 'info')
    }
  };

  const remove = () => {
    let ids = orderid ? [parseInt(orderid)] : [];
    dispatch(orderSlice.actions.setIsFetching(true));
    if (ids.length > 0) {
      ENDPOINTS.orders()
        .delete({ ids })
        .then(() => {
          dispatch(orderSlice.actions.setIsFetching(false));

          alert(
            { en: 'your deletion was succefull', ar: 'تم الحذف بنجاح' },
            'success',
          );
          navigate('/orders');
          dispatch(ordersSlice.actions.deleteOrders(ids));

          //dispatch(purchaseOrdersSlice.actions.deleteMaterials(ids));
        })
        .catch((err: AxiosError) => {
          dispatch(orderSlice.actions.setIsFetching(false));

          alertError500(err);
        });
    }
  };

  ///// handle Summary glass and glass work
  const handleSummaries = (): {
    glass_summary: string,
    glass_work_summary: string,
    glass_ids: number[],
    glass_work_ids: number[],
  } | null => {
    if (formik.values) {
      let summary_glass: string[] = [];
      let summary_galss_work: string[] = [];
      let summary_glass_ids: number[] = []
      let summary_glass_work_ids: number[] = []
      let summary_results = {
        glass_summary: '',
        glass_work_summary: '',
        glass_ids: '',
        glass_work_ids: '',

      }
      formik.values.order_details?.map((key, index) => {
        if (key['glass_id'] && state.glasses['general']
        ) {
          let glass_name = '';

          let selectedGlass = state.glasses['general']
            ? state.glasses['general'].filter(
              (ele) => ele.id === key?.glass_id,
            )
            : null;

          if (selectedGlass) glass_name = selectedGlass[0]?.name;
          if (glass_name && !summary_glass_ids.includes(key.glass_id)) {
            summary_glass.push(glass_name);
            summary_glass_ids.push(key.glass_id)
          }
        }
        if (key.glass_work_id
        ) {
          let glasswork_name = '';
          let selectedGlasswork = state.glassWorks[index]
            ? state.glassWorks[index].filter(
              (ele) => ele.gwid === key?.glass_work_id,
            )
            : null;

          if (selectedGlasswork) glasswork_name = selectedGlasswork[0]?.name;
          if (glasswork_name && !summary_glass_work_ids.includes(key.glass_work_id)) {
            summary_galss_work.push(glasswork_name);
            summary_glass_work_ids.push(key.glass_work_id)
          }
        }
      });

      if (summary_glass.length > 0 || summary_galss_work.length > 0) {
      
        return {
          glass_summary: summary_glass.join(','),
          glass_work_summary: summary_galss_work.join(','),
          glass_ids: summary_glass_ids,
          glass_work_ids: summary_glass_work_ids,

        }


      }

    }
    return null
  }
  useEffect(() => {
    dispatch(orderSlice.actions.initGlassworks())

  }, []);
  useEffect(() => {
    ENDPOINTS.orders().statusOperations({ page: 1, page_size: 100 })
      .then((res: any) => {
        if (res.data && res.data.data && res.data.data.status_operations) {
          dispatch(orderSlice.actions.setStatusOperations(res.data.data.status_operations))
        }
      })
      .catch((err: any) => alertError500(err))
  }, [])

  //////////////// Debouncing //////////////////

  useEffect(()=>{
    if (debounce && Boolean(debounce?.key_trigger)){
      let {values,helper}=debounce
      if (helper && helper.index){
          if (debounce?.key_trigger === 'glasswork_code') {

                let [single_price,total_price,price,raw_price,min_arae] = handlePrices(values[helper.index],state)
                values[helper.index]['total_price']=total_price
                values[helper.index]['price']=price
                values[helper.index]['single_price']=single_price
                values[helper.index]['raw_price']=raw_price
                values[helper.index]['area']=min_arae
                
            

          }
        //   else if (debounce?.key_trigger === 'glass_code') {
        //       let [single_price,total_price,price,raw_price] = handlePrices( values[helper.index])
        //       values[helper.index]['total_price']=total_price
        //       values[helper.index]['price']=price
        //       values[helper.index]['single_price']=single_price
        //       values[helper.index]['raw_price']=raw_price
          
          
        // }

      formik.setValues(pre => ({ ...pre, order_details: values }))

}

  }
},[debounce])



  //console.log("errors", formik.errors)
  //console.log(state)
  //console.log("values", formik.values)
  //console.log("touched", formik.touched)
  //console.log('row',row)

  let key1 = t('glass_work_id')
  let key2 = t("glass_id")
  let key5 = t("length")
  let key6 = t("width")
  let spans: { [key: string]: number } = {}
  let spans_1: { [key: string]: number } = {}
  let units: { [key: string]: string } = {}
  spans[key1] = 2
  spans[key2] = 2
  spans_1[key1] = 1
  spans_1[key2] = 1
  units[key5] = `(${t("cm")})`
  units[key6] = `(${t("cm")})`

  let total_number=  formik.values.order_details?.reduce(
                    (ac,item)=>
                       { return ac + (item.total_price ? item.total_price : 0) }
                      ,0)
   
  if (state.isFetching) {
    return (
      <Grid container>
        <Grid  size={12} display="flex" justifyContent={'center'}>
          <EllipsisLoader />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container rowGap={1} paddingBottom={1}>
      <MySuccessMark succeed={isSucceed} setSucceed={setIsSucceed} />
      <ErrorMark failed={isFailed} setFailed={setIsFailed} />
      {/* <Grid  container size={12} justifyContent={'flex-end'}>
        <Backbutton previousPageRoute="/orders" />
      </Grid> */}
         {/* <Backbutton previousPageRoute="/orders" /> */}
      <Title title={t("order_details")} backbutton_path='/orders'/>
      <Grid  container size={12} rowGap={1}>
        <Grid  size={12}>
          <TableContainer>
          { isMobile?
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('client_name')}</TableCell>

                  <TableCell>{t('phone')}</TableCell>
                  <TableCell>{t('order_no')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
                <TableRow >
                  <TableCell

                  >{state.client?.client?.data.name}</TableCell>

                  <TableCell>{state.client?.phone}</TableCell>
                  <TableCell>{state.order.order_no }</TableCell>
                </TableRow >  
            </TableBody>
           <TableRow>
            <TableCell colSpan={3}></TableCell>
           </TableRow>

              <TableHead>
              <TableRow>
              <TableCell>{t('order_date')}</TableCell>
                   <TableCell>{t('total')}</TableCell>
                  <TableCell style={{ textAlign: 'center' }}>{t('note')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
                <TableRow >
                   <TableCell>{state.order.date}</TableCell>
                  <TableCell>{
               
                      }
                    </TableCell>
                  <TableCell>
                    <textarea
                      rows={3}
                      name="summary"
                      placeholder={t('summary') + ' *'}
                      onChange={(e: React.ChangeEvent) => {
                        if (state.order.orderstatus && state.order.orderstatus[0].code >= 3) return
                        setSummaries((pre) => ({
                          ...pre,
                          summary: (e.target as HTMLInputElement).value,
                        }));
                      }}
                      value={summaries.summary}
                      style={{
                        padding: '5px'
                        , outline: 'none'
                        , lineHeight: 1
                        , width: '100%'
                        , background: '#F7F7F7'
                        , border: 'none'
                        , resize: 'none'
                      }}

                    />
                  </TableCell>
                </TableRow >  
            </TableBody>

             {/* <TableRow>
            <TableCell colSpan={3}></TableCell>
           </TableRow> */}
           
           <TableHead>
              <TableRow>
                  <TableCell style={{ textAlign: 'center' }}>{t('glass_work_summary')}</TableCell>
                  <TableCell align="center">{t('status')}</TableCell>

                  <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
                <TableRow >
                 <TableCell>
                    <textarea
                      rows={3}
                      name="glass_work_summary"
                      placeholder={t('glass_work_summary') + ' *'}
                      onChange={(e: React.ChangeEvent) => {
                        if (state.order.orderstatus && state.order.orderstatus[0].code >= 3) return
                        setSummaries((pre) => ({
                          ...pre,
                          summary: (e.target as HTMLInputElement).value,
                        }));
                      }}
                      value={summaries.glass_work_summary}
                      style={{
                        padding: '5px'
                        , outline: 'none'
                        , lineHeight: 1
                        , width: '100%'
                        , background: '#F7F7F7'
                        , border: 'none'
                        , resize: 'none'
                      }}

                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    <span style={{ margin: '0 1 px' }}>
                      {state.order.orderstatus
                        ? `${t(state.order.orderstatus[0].status)}`
                        : ''}
                    </span>
                    <OrderStatusMenu
                      status={
                        state.order.orderstatus
                          ? state.order.orderstatus[0].status
                          : ''
                      }
                      statusMenu={state.order.orderstatus ?? []}
                    />
                  </TableCell >


                  <TableCell
                    sx={{


                    }}>
                    <div style={{ display: 'flex' }}>

                      {state.order.orderstatus ? (
                        state.order.orderstatus[0].status !== 'Open' ? (
                          <OperationStatus
                            disabled={!havePermission('Previous Status')
                              || state.order.orderstatus[0].code >= 5
                            }
                            style={{ margin: '0 1px' }}
                            id={
                              state.operationsStatus.filter(
                                (ele) =>
                                  ele.status ===
                                  state.order.orderstatus?.[0].status
                                  && ele.function !== "Show"
                              )[0]
                                ? state.operationsStatus.filter(
                                  (ele) =>
                                    ele.status ===
                                    (state.order.orderstatus
                                      ? state.order.orderstatus[0].status
                                      : ''),
                                )[0].id
                                : -1
                            }
                            fun={() => {
                              let res = ENDPOINTS.orders()
                                .previousStatus({
                                  order_id: state.order.id ?? 0,
                                  status: state.order.orderstatus
                                    ? state.order.orderstatus[0].status
                                    : '',
                                })
                                .then((res: any) => {
                                  if (res.data.data) {
                                    dispatch(
                                      orderSlice.actions.setOrder(res.data.data),
                                    );
                                  }
                                  return true;
                                })
                                .catch((err: any) => {
                                  alertError500(err);
                                  return true;
                                });
                              return res;
                            }}
                          />
                        ) : null
                      ) : null}
                      {state.order.orderstatus ? (
                        state.order.orderstatus[0].status !== "Closed" ? (
                          <OperationStatus
                            disabled={!havePermission('Next Status')}
                            id={
                              state.operationsStatus
                                .filter(
                                  (ele) =>
                                    ele.status ===
                                    state.order.orderstatus?.[0].status
                                    && ele.function !== 'Show'
                                  ,
                                )
                                .at(-1)?.id ?? 0
                            }
                            style={{ margin: '0 1px' }}
                            fun={() => {
                              let res = ENDPOINTS.orders()
                                .nextStatus({
                                  order_id: state.order.id ?? 0,
                                  status: state.order.orderstatus
                                    ? state.order.orderstatus[0].status
                                    : '',
                                })
                                .then((res: any) => {
                                  if (res.data.data) {
                                    dispatch(
                                      orderSlice.actions.setOrder(res.data.data),
                                    );
                                  }
                                  return true;
                                })
                                .catch((err: any) => {

                                  alertError500(err);
                                  return true;
                                });
                              return res;
                            }}
                          />
                        ) : null
                      ) : null}
                      {state.order.orderstatus ? (
                        handleStaticFunction(state.order.orderstatus[0].status
                          , state.order.id
                          , state.order.bill_id
                          , state.order.orderstatus[0].code)
                      ) : null}


                    </div>
                  </TableCell>
                </TableRow >  
            </TableBody>
          </Table>
          :
           <Table>
              <TableHead>

                <TableRow>
                  <TableCell>{t('client_name')}</TableCell>

                  <TableCell>{t('phone')}</TableCell>
                  <TableCell>{t('order_no')}</TableCell>
                  <TableCell>{t('order_date')}</TableCell>
                   <TableCell>{t('total')}</TableCell>
                  <TableCell style={{ textAlign: 'center' }}>{t('note')}</TableCell>
                  <TableCell style={{ textAlign: 'center' }}>{t('glass_work_summary')}</TableCell>
                  <TableCell align="center">{t('status')}</TableCell>

                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow >
                  <TableCell

                  >{state.client?.client?.data.name}</TableCell>

                  <TableCell>{state.client?.phone}</TableCell>
                  <TableCell>{state.order.order_no }</TableCell>
                  <TableCell>{state.order.date?.replaceAll('-','/')}</TableCell>
                       
                  <TableCell>
                         {
                         total_number?.toFixed(2)
                        
                         }
                      
                      
                    </TableCell>
                       
                  <TableCell>
                    <textarea
                      rows={3}
                      name="summary"
                      placeholder={t('summary') + ' *'}
                      onChange={(e: React.ChangeEvent) => {
                        if (state.order.orderstatus && state.order.orderstatus[0].code >= 3) return
                        setSummaries((pre) => ({
                          ...pre,
                          summary: (e.target as HTMLInputElement).value,
                        }));
                      }}
                      value={summaries.summary}
                      style={{
                        padding: '5px'
                        , outline: 'none'
                        , lineHeight: 1
                        , width: '100%'
                       
                        , border: 'none'
                        , resize: 'none'
                      }}

                    />
                  </TableCell>
                   <TableCell>
                    <textarea
                      rows={3}
                      name="glass_work_summary"
                      placeholder={t('glass_work_summary') + ' *'}
                      onChange={(e: React.ChangeEvent) => {
                        if (state.order.orderstatus && state.order.orderstatus[0].code >= 3) return
                        setSummaries((pre) => ({
                          ...pre,
                          summary: (e.target as HTMLInputElement).value,
                        }));
                      }}
                      value={summaries.glass_work_summary}
                      style={{
                        padding: '5px'
                        , outline: 'none'
                        , lineHeight: 1
                        , width: '100%'
                        //, background: '#F7F7F7'
                        , border: 'none'
                        , resize: 'none'
                      }}

                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    <span style={{ margin: '0 1 px' }}>
                      {state.order.orderstatus
                        ? `${t(state.order.orderstatus[0].status)}`
                        : ''}
                    </span>
                    <OrderStatusMenu
                      status={
                        state.order.orderstatus
                          ? state.order.orderstatus[0].status
                          : ''
                      }
                      statusMenu={state.order.orderstatus ?? []}
                    />
                  </TableCell >


                  <TableCell
                    sx={{


                    }}>
                    {/* <div style={{ display: 'flex' }}> */}
                    <Grid container size={12} display={'flex'} justifyContent="center"
                    flexWrap={'wrap'}>
                      {state.order.orderstatus ? (
                        state.order.orderstatus[0].status !== 'Open' && state.order.orderstatus[0].code !== 4 ? (
                          <div>
                          <OperationStatus
                            disabled={!havePermission('Previous Status')
                        
                            }
                            style={{ margin: '0 1px' }}

                            id={
                              state.operationsStatus.filter(
                                (ele) =>
                                  ele.status ===
                                  state.order.orderstatus?.[0].status
                                  && ele.function !== "Show"
                              )[0]
                                ? state.operationsStatus.filter(
                                  (ele) =>
                                    ele.status ===
                                    (state.order.orderstatus
                                      ? state.order.orderstatus[0].status
                                      : ''),
                                )[0].code
                                : -1
                            }
                            fun={() => {
                              let res = ENDPOINTS.orders()
                                .previousStatus({
                                  order_id: state.order.id ?? 0,
                                  status: state.order.orderstatus
                                    ? state.order.orderstatus[0].status
                                    : '',
                                })
                                .then((res: any) => {
                                  if (res.data.data) {
                                    dispatch(
                                      orderSlice.actions.setOrder(res.data.data),
                                    );
                                  }
                                  return true;
                                })
                                .catch((err: any) => {
                                  alertError500(err);
                                  return true;
                                });
                              return res;
                            }}
                          />
                          </div>
                        ) : null
                      ) : null}
                      {state.order.orderstatus ? (
                        state.order.orderstatus[0].status !== "Closed" ? (
                          <div>
                          <OperationStatus
                            disabled={!havePermission('Next Status')}
                            next={true}
                            id={
                              state.operationsStatus
                                .filter(
                                  (ele) =>
                                    ele.status ===
                                    state.order.orderstatus?.[0].status
                                    && ele.function !== 'Show'
                                  ,
                                )
                                .at(-1)?.code ?? 0
                            }
                            style={{ margin: '0 1px' }}
                            fun={() => {
                              let res = ENDPOINTS.orders()
                                .nextStatus({
                                  order_id: state.order.id ?? 0,
                                  status: state.order.orderstatus
                                    ? state.order.orderstatus[0].status
                                    : '',
                                })
                                .then((res: any) => {
                                  if (res.data.data) {
                                    dispatch(
                                      orderSlice.actions.setOrder(res.data.data),
                                    );
                                  }
                                  return true;
                                })
                                .catch((err: any) => {

                                  alertError500(err);
                                  return true;
                                });
                              return res;
                            }}
                          />
                          </div>
                        ) : null
                      ) : null}
                      {state.order.orderstatus ? (
                        handleStaticFunction(state.order.orderstatus[0].status
                          , state.order.id
                          , state.order.bill_id
                          , state.order.orderstatus[0].code)
                      ) : null}

                   </Grid>

                    {/* </div> */}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>}
          </TableContainer>
        </Grid>
      
       
      </Grid>
      <Grid  container size={12}>
        <Grid  container size={12} >
          <InputTable
            headers={[
              t('glass_work_id'),
              t('glasswork_code'),
              t('piece_code'),
              t('length'),
              t('width'),
              t('piece_count'),
              t('glass_id'),
              t('glass_code'),
            ]}
            body={() => generateTableBody()}
            spans={spans}
            units={units}
          />
        </Grid>
        {!isPc && <Grid  container size={12} justifyContent={'center'}>
          {enterButton(enterClicked)}
        </Grid>}
        <Grid  container size={12}>
          <EditbleTable
            array_name='order_details'
            spans={spans_1}
            handleChange={customHandleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors}
            has_general_options={true}
            lines_number={formik.values ? Object.keys(formik.values).length : 0}
            values={(() => {
              let obj: { [key: number]: order_details_extended} = {};
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              formik.values.order_details
                ? formik.values.order_details.map(
                  (ele, index) =>
                  (obj[index] = {
                    glass_work_id: ele.glass_work_id,
                    glasswork_code: ele.glasswork_code,
                    piece_code: ele.piece_code,
                    length: ele.length,
                    width: ele.width,
                    piece_count: ele.piece_count,
                    price:ele.price,
                    total_price:ele.total_price,
                    glass_id: ele.glass_id,
                    glass_code: ele.glass_code,
                    serial_number: index + 1,
                  }),
                )
                : [
                  {
                    glass_work_id: '',
                    glasswork_code: '',
                    piece_code: '',
                    length: '',
                    width: '',
                    piece_count: '',
                    price:0,
                    total_price:0,
                    glass_id: '',
                    glass_code: '',
                    serial_number: 1,
                  },
                ];
              return obj;
            })()}
            touched={formik.touched}
            number_inputs={['price','piece_count','width','length']}
            headers={[
              t('glass_work_id'),
              t('glasswork_code'),
              t('code'),
              t('length'),
              t('width'),
              t('count'),
              t('price'),
              t('total_price'),
              t('glass_id'),
              t('glass_code'),
              t('serial_number'),
            ]}
            selectInput={['glass_id', 'glass_work_id']}
            options={{ glass_id: state.glasses, glass_work_id: state.glassWorks }}
            units={units}
            removeLine={handleRemoveLine}
            copyLine={handleCopyLine}
          />
        </Grid>
        <Grid  container size={12} justifyContent="center">
          <>
            <Grid
              
              container
              size={6}
              justifyContent="center"
              alignItems={'center'}
              paddingBottom={2}>
              {true ? (
                <>
                  <Grid size={3} mx={1}>
                    <GreenButton
                      label={t('save')}
                      fun={() => submit()}
                      disabled={isLoading || 
                        (state.order.orderstatus && state.order.orderstatus[0].code >= 3)
                      ||!formik.isValid}
                      fullWidth={true}>
                      {isLoading ? (
                        <CircularProgress sx={{ color: 'white' }} size={20} />
                      ) : (
                        <Save sx={{ color: 'white' }} />
                      )}
                    </GreenButton>
                  </Grid>

                { false && <Grid size={3} mx={1}>
                    <WhiteButton
                      label={t('cancel')}
                      fun={() => {
                        formik.resetForm();
                        navigate('/orders');
                      }}
                      fullWidth={true}>
                      <Cancel color="error" />
                    </WhiteButton>
                  </Grid>}
                </>
              ) : null}
             {false &&
              <Grid size={3} mx={1}>
                <WhiteButton
                  fun={() =>
                    Confirm({
                      message: t('delete_confirmation'),
                      onConfirm: () => remove(),
                    })
                  }
                  label={t('delete')}
                  fullWidth={true}
                  disabled={!havePermission("Delete Order") || (state.order.orderstatus && (state.order?.orderstatus?.[0]?.code??0) >= 3)}
                >
                  <Delete sx={{ color: 'red' }} />
                </WhiteButton>
              </Grid>}
            </Grid>
          </>
        </Grid>
        <div
          id="includeMe"
          style={{ position: 'absolute', visibility: 'hidden', zIndex: -1 }}>
          {deliveryOrderPrint?.open && (
            <PrintDeliveryOrder
              close={() =>
                setDeliveryOrderPrint((pre) => ({ ...pre,open: false }))
              }
              data={deliveryOrderPrint.data}
            />
          )}
          {printOrder.open && (
            <PrintOrder
              close={() => setPrintOrder((pre) => ({ ...pre, open: false }))}
              data={printOrder.data}
              setWait={setWait}
            />
          )}
          {
            printPricse.open && (
              <PrintPrices
                close={() => setPrintPrices((pre) => ({ ...pre, open: false }))}
                data={printPricse.data}
                setWait={setWait}
                tax_percent={cookie?.company_info?.tax_percent}
              />
            )
          }

        </div>
        {wait && <Wait />}
      </Grid>
    </Grid>
  );
};
export default EditOrder;